const disabledFields = new WeakMap();

const beforeActiveStorageSubmitHandler = (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target : undefined;
  const submitter = event.submitter || undefined;

  if (form) {
    if (submitter) {
      const shouldDisable =
        submitter.formAction.endsWith('_modal') || submitter.formMethod === 'get';

      if (shouldDisable) {
        const files = form.querySelectorAll('[data-direct-upload-url]');
        const disabled = [];

        files.forEach((file) => {
          if (!file.disabled) {
            disabled.push(file);
            file.disabled = true;
          }
        });

        disabledFields.set(event, disabled);
      }
    }
  }
};

const afterActiveStorageSubmitHandler = (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target : undefined;

  if (form) {
    const disabled = disabledFields.get(event);

    if (disabled) {
      disabled.forEach((file) => {
        file.disabled = false;
      });

      disabledFields.delete(event);
    }
  }
};

export const startBeforeActiveStorage = () => {
  document.addEventListener('submit', beforeActiveStorageSubmitHandler, true);
};

export const startAfterActiveStorage = () => {
  document.addEventListener('submit', afterActiveStorageSubmitHandler, true);
};
